// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ByEkc","video":"_3h92n"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/VideoBg/styles.scss
 ** module id = 465
 ** module chunks = 0
 **/